import { render, staticRenderFns } from "./Solicitudes.vue?vue&type=template&id=5e96c3b9&scoped=true&"
import script from "./Solicitudes.vue?vue&type=script&lang=ts&"
export * from "./Solicitudes.vue?vue&type=script&lang=ts&"
import style0 from "./Solicitudes.vue?vue&type=style&index=0&id=5e96c3b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e96c3b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5e96c3b9', component.options)
    } else {
      api.reload('5e96c3b9', component.options)
    }
    module.hot.accept("./Solicitudes.vue?vue&type=template&id=5e96c3b9&scoped=true&", function () {
      api.rerender('5e96c3b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Solicitudes/Solicitudes.vue"
export default component.exports